"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickStatus = void 0;
var ClickStatus;
(function (ClickStatus) {
    ClickStatus["ORGANIC"] = "ORGANIC";
    ClickStatus["GOOD"] = "GOOD";
    ClickStatus["SUSPICIOUS"] = "SUSPICIOUS";
    ClickStatus["BAD"] = "BAD";
    ClickStatus["IGNORED"] = "IGNORED";
    ClickStatus["WHITELSITED"] = "WHITELSITED";
})(ClickStatus = exports.ClickStatus || (exports.ClickStatus = {}));
